import React, { JSXElementConstructor, ReactElement } from 'react';
import { LockOutlined } from '@ant-design/icons';
import AuthLayout from 'components/auth';
import RightItems from '../rightItems';
import AuthInputForm from '../inputForm';
import { useLanguage } from 'hooks/Languages/useLanguage';
import { Button, Checkbox, Flex, Form, FormInstance, Input } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import urls from 'routes/urls';
import './index.scss';
import DynamicInput from './DynamicInput';

interface LoginPageProps {
  loading: boolean;
  form: FormInstance<any>;
  onHandleSubmit: () => void;
  countryList: any;
  selectedCountry: any;
  setSelectedCountry: any;
  isAdminFirstLogin: any;
  isUserFirstLogin: any;
  contextHolder: ReactElement<any, string | JSXElementConstructor<any>>;
}

const LoginPage: React.FC<LoginPageProps> = ({
  loading,
  form,
  onHandleSubmit,
  contextHolder,
  countryList,
  setSelectedCountry,
  selectedCountry,
  isAdminFirstLogin,
  isUserFirstLogin,
}) => {
  const { translate } = useLanguage();
  const navigate = useNavigate();

  const validatePassword = (_: any, value: string) => {
    const password = form.getFieldValue('new_password');
    if (password && value !== password) {
      return Promise.reject(new Error(translate('Passwords do not match!')));
    }
    return Promise.resolve();
  };

  return (
    <AuthLayout
      items={<RightItems />}
      form={
        <AuthInputForm
          form={form}
          onFinish={onHandleSubmit}
          title={translate('Welcome back')}
        >
          {contextHolder}
          <DynamicInput
            translate={translate}
            countryList={countryList}
            selectedCountry={selectedCountry}
            setSelectedCountry={setSelectedCountry}
          />
          <Form.Item
            name="password"
            label={translate('Password')}
            rules={[
              {
                required: true,
                message: translate('Please input your password'),
              },
            ]}
          >
            <Input.Password
              type="password"
              size="large"
              placeholder={translate('password')}
              prefix={<LockOutlined />}
            />
          </Form.Item>
          {isAdminFirstLogin && (
            <Form.Item
              name="otp"
              label={translate('OTP')}
              rules={[
                {
                  required: true,
                  message: translate(
                    'Enter the OTP sent to your phone or email'
                  ),
                },
              ]}
            >
              <Input.OTP size="large" length={6} style={{ width: '80%' }} />
            </Form.Item>
          )}
          {isUserFirstLogin && (
            <>
              {' '}
              <Form.Item
                name="new_password"
                label={translate('Set your new password')}
                rules={[
                  {
                    required: true,
                    message: translate('Please input your password!'),
                  },
                  {
                    pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{8,}$/,
                    message: translate(
                      'Password must be at least 8 characters long and include uppercase letters, lowercase letters, and numbers.'
                    ),
                  },
                ]}
                hasFeedback
              >
                <Input.Password
                  type="password"
                  size="large"
                  placeholder={translate('password')}
                  prefix={<LockOutlined />}
                />
              </Form.Item>
              <Form.Item
                name="confirmPassword"
                label={translate('Confirm Password')}
                dependencies={['new_password']}
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: translate('Please confirm your password!'),
                  },
                  { validator: validatePassword },
                ]}
              >
                <Input.Password
                  size="large"
                  placeholder={translate('Confirm your password')}
                />
              </Form.Item>
            </>
          )}
          <Form.Item>
            <Flex justify="space-between" align="center">
              <Form.Item name="remember" valuePropName="checked" noStyle>
                <Checkbox disabled={loading}>
                  {translate('Remember me')}
                </Checkbox>
              </Form.Item>
              <Link to={urls.resetPassword}>
                {translate('Forgot password')}
              </Link>
            </Flex>
          </Form.Item>
          <Form.Item>
            <Button
              block
              style={{ width: '100%' }}
              size="large"
              type="primary"
              htmlType="submit"
              className="large-margin-top"
              loading={loading}
            >
              {translate('Log in')}
            </Button>
            <div className="xxlarge-margin-top" style={{ textAlign: 'center' }}>
              <span className="grey-text">
                {' '}
                {translate("Don't have an account?")}
              </span>
              <Button type="link" onClick={() => navigate(urls.register)}>
                <span>{translate('Sign up for free')}</span>
              </Button>
            </div>
          </Form.Item>
          <Flex vertical>
            <span>{translate('For assistance, email us at')}</span>
            {/* <Flex vertical>
              <span>{translate('Tel')}: (+243) 970310329</span>
              <span style={{ color: 'green' }}>
                {translate('Whatsapp')}: (+243) 970310329
              </span>
            </Flex> */}
            <Flex gap="small" align="center">
              <span style={{ color: 'green' }}>
                {translate('Email')}: danielcroga5@gmail.com, nankim45@gmail.com
              </span>
            </Flex>
          </Flex>
        </AuthInputForm>
      }
    />
  );
};

export default LoginPage;
